export enum ClosedProgramSpendCorrectionOutcome {
  /** The check started but never recorded an outcome: the recount threw or the process died. */
  Attempted = 'attempted',
  /** Stored spend came from a recount past the program's end and was replaced (or would be). */
  Corrected = 'corrected',
  /** Stored spend differs from the recount, but no later date reproduces it: left alone. */
  Unexplained = 'unexplained',
  Unchanged = 'unchanged',
}
